import CheckedCols from './CheckedCols';

export default CheckedCols;
